export default {
	'no-debt-visits-to-show': 'NO DEBT VISITS TO SHOW',
	'filter-customers': 'Customers',
	'filter-status': 'Status',
	'payment-status': {
		unpaid: 'Unpaid',
		'partially-paid': 'Partially paid',
		paid: 'Paid',
	},
}
